import ActionPanel from '@components/layout/action-panel/ActionPanel';
import ArtifactPanel from '@components/layout/artifact-panel/ArtifactPanel';
import Main from '@components/layout/main/Main';
import RightPanel from '@components/layout/right-panel/RightPanel';
import SettingsPage from '@components/settings/SettingsPage';
import { WindowSize } from '@enums';
import { useWindowSize } from '@hooks';
import { useChatStore } from '@store/chat';
import { useShellStore } from '@store/shell';
import { isSettingsPath } from '@utils';
import { useMemo } from 'react';

function MainContent() {
  const hasStartedChat = useChatStore((state) => state.hasStartedChat());
  const browserPathname = useShellStore((state) => state.browserPathname);
  const windowSize = useWindowSize();
  const isSettings = isSettingsPath(browserPathname);
  const isBelowExtraLarge =
    windowSize.value !== WindowSize.ExtraLarge &&
    windowSize.value !== WindowSize.ExtraExtraLarge;
  const isAtMost768 = windowSize.isSmall || windowSize.isExtraSmall;

  const actionPanel = useMemo(
    () =>
      hasStartedChat || (isBelowExtraLarge && !isAtMost768) ? (
        <ActionPanel />
      ) : null,
    [hasStartedChat, isAtMost768, isBelowExtraLarge]
  );

  if (isSettings) {
    return <SettingsPage />;
  }

  return (
    <>
      {actionPanel}
      <Main />
      <RightPanel />
      <ArtifactPanel />
    </>
  );
}

export default MainContent;
